export const FETCH_CARATAGE_REQUEST = 'FETCH_CARATAGE_REQUEST';
export const FETCH_CARATAGE_SUCCESS = 'FETCH_CARATAGE_SUCCESS';
export const FETCH_CARATAGE_FAILURE = 'FETCH_CARATAGE_FAILURE';

export const ADD_CARATAGE_REQUEST = 'ADD_CARATAGE_REQUEST';
export const ADD_CARATAGE_SUCCESS = 'ADD_CARATAGE_SUCCESS';
export const ADD_CARATAGE_FAILURE = 'ADD_CARATAGE_FAILURE';

export const UPDATE_CARATAGE_REQUEST = 'UPDATE_CARATAGE_REQUEST';
export const UPDATE_CARATAGE_SUCCESS = 'UPDATE_CARATAGE_SUCCESS';
export const UPDATE_CARATAGE_FAILURE = 'UPDATE_CARATAGE_FAILURE';

export const DELETE_CARATAGE_REQUEST = 'DELETE_CARATAGE_REQUEST';
export const DELETE_CARATAGE_SUCCESS = 'DELETE_CARATAGE_SUCCESS';
export const DELETE_CARATAGE_FAILURE = 'DELETE_CARATAGE_FAILURE';

export const SET_CARATAGE_EDIT = 'SET_CARATAGE_EDIT';
export const CLEAR_CARATAGE_EDIT = 'CLEAR_CARATAGE_EDIT'; 